"use client";

import { c as _c } from "react-compiler-runtime";
import NextImage from "next/image";
import { Text } from "@/components/primitives";
type DemoPersona = {
  id: string;
  label: string;
  thumbnailUrl: string;
  secondaryThumbnailUrl?: string;
};
type DemoPersonaSelectorProps = {
  personas: DemoPersona[];
  onSelect: (personaId: string) => void;
  disabled?: boolean;
  fullBody?: boolean;
};
export function DemoPersonaSelector(t0) {
  const $ = _c(12);
  const {
    personas,
    onSelect,
    disabled: t1,
    fullBody: t2
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const fullBody = t2 === undefined ? false : t2;
  const imageClassName = fullBody ? "object-cover object-top" : "object-cover";
  const usesPairedLayout = personas.some(_temp);
  const containerClassName = usesPairedLayout ? "grid w-full grid-cols-3 gap-2 px-1 py-3" : "flex w-full flex-wrap justify-center gap-3 px-1 py-3";
  let t3;
  if ($[0] !== disabled || $[1] !== imageClassName || $[2] !== onSelect || $[3] !== personas) {
    let t4;
    if ($[5] !== disabled || $[6] !== imageClassName || $[7] !== onSelect) {
      t4 = persona_0 => {
        const hasImagePair = Boolean(persona_0.secondaryThumbnailUrl);
        const buttonClassName = hasImagePair ? "flex flex-col items-center gap-1.5 rounded-3xl bg-white/10 px-2 py-2 shadow-lg shadow-black/20 ring-1 ring-white/15 transition hover:scale-[1.03] hover:bg-white/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 disabled:pointer-events-none disabled:opacity-40" : "flex shrink-0 flex-col items-center gap-1.5 rounded-xl px-3 py-2 transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 disabled:pointer-events-none disabled:opacity-40";
        return <button className={buttonClassName} disabled={disabled} key={persona_0.id} type="button" onClick={() => onSelect(persona_0.id)}><div className={hasImagePair ? "flex -space-x-4" : undefined}><DemoPersonaThumbnail imageClassName={imageClassName} label={persona_0.label} size={hasImagePair ? "paired" : "single"} src={persona_0.thumbnailUrl} />{persona_0.secondaryThumbnailUrl ? <DemoPersonaThumbnail imageClassName={imageClassName} label={`${persona_0.label} profile`} size="paired" src={persona_0.secondaryThumbnailUrl} /> : null}</div><Text component="span" text={persona_0.label} tone="white" variant="caption" /></button>;
      };
      $[5] = disabled;
      $[6] = imageClassName;
      $[7] = onSelect;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = personas.map(t4);
    $[0] = disabled;
    $[1] = imageClassName;
    $[2] = onSelect;
    $[3] = personas;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[9] !== containerClassName || $[10] !== t3) {
    t4 = <div className={containerClassName}>{t3}</div>;
    $[9] = containerClassName;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}
function _temp(persona) {
  return Boolean(persona.secondaryThumbnailUrl);
}
type DemoPersonaThumbnailProps = {
  imageClassName: string;
  label: string;
  size: "single" | "paired";
  src: string;
};
function DemoPersonaThumbnail(t0) {
  const $ = _c(7);
  const {
    imageClassName,
    label,
    size,
    src
  } = t0;
  const sizeClassName = size === "paired" ? "h-16 w-16" : "h-14 w-14";
  const t1 = `relative ${sizeClassName} overflow-hidden rounded-full border border-white/40 bg-black/20 shadow-md shadow-black/30`;
  let t2;
  if ($[0] !== imageClassName || $[1] !== label || $[2] !== src) {
    t2 = <NextImage alt={label} className={imageClassName} fill={true} sizes="64px" src={src} />;
    $[0] = imageClassName;
    $[1] = label;
    $[2] = src;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}